import ImageOptimize from '@/components/ImageOptimize'

const policies = [
  {
    src: '/assets/images/policy1.svg',
    alt: '100% Hàng chính hàng',
    title: '100% Hàng chính hàng',
    description:
      'Cam kết hàng chính hãng, bảo hành chính hãng, mới 100% - Đền 300% nếu không đúng',
  },
  {
    src: '/assets/images/policy2.svg',
    alt: 'Đổi trả dễ dàng',
    title: 'Đổi trả dễ dàng',
    description:
      'Đổi Trả từ 7 ngày đến 30 ngày, theo chính sách đổi trả tại Shop1',
  },
  {
    src: '/assets/images/policy3.svg',
    alt: 'Giao hàng nhanh',
    title: 'Giao hàng nhanh',
    description: 'Giao hàng từ 2 giờ đến 4 giờ trong nội thành',
  },
  {
    src: '/assets/images/policy4.svg',
    alt: 'Thương hiệu đảm bảo',
    title: 'Thương hiệu đảm bảo',
    description:
      'Thanh toán an toàn nhiều hình thức COD, chuyển khoản, trả góp ',
  },
]

const HighlightServices = ({ className }: { className?: string }) => {
  return (
    <div className={`${className} container mx-auto flex p-5 pt-8`}>
      {policies.map((policy, index) => (
        <div key={index} className='w-1/4'>
          <div className='flex w-4/5 flex-col items-center p-2 text-center'>
            <ImageOptimize
              src={policy.src}
              alt={policy.alt}
              width={60}
              height={60}
              className='overflow-hidden'
            />
            <span className='mt-2 text-sm font-semibold text-main'>
              {policy.title}
            </span>
            <span className='mt-1 text-sm text-sub'>{policy.description}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default HighlightServices
